angular.module('workflow.app')
.filter 'startswith', ->
  (items, prefix, itemProperty) ->
    prefix = prefix.toLowerCase()
    items.filter (item) ->
      findIn = item.name.toString().toLowerCase()
      isInAlias = (a for a in item.aliases or [] when a.toLowerCase().indexOf(prefix) is 0)
      findIn.indexOf(prefix) is 0 or isInAlias.length > 0
